//export const baseUrl = 'http://localhost:4000'
export const baseUrl = 'https://api.fictiongenie.com'
export const appUrl = 'https://story.fictiongenie.com'